/**
 * @generated SignedSource<<92db8a93c8f7dbd5911f987064561b84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CarryForwardSuggestedActionMutation$variables = {
  noteId: string;
  type: string;
};
export type CarryForwardSuggestedActionMutation$data = {
  readonly noteCarryForwardBlocks: {
    readonly note: {
      readonly actionItemsCarriedForward: boolean;
      readonly talkingPointsCarriedForward: boolean;
    };
  } | null;
};
export type CarryForwardSuggestedActionMutation = {
  response: CarryForwardSuggestedActionMutation$data;
  variables: CarryForwardSuggestedActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionItemsCarriedForward",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "talkingPointsCarriedForward",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CarryForwardSuggestedActionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteCarryForwardBlocks",
        "kind": "LinkedField",
        "name": "noteCarryForwardBlocks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CarryForwardSuggestedActionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteCarryForwardBlocks",
        "kind": "LinkedField",
        "name": "noteCarryForwardBlocks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68c10238fed9dc860f557f5569f300d4",
    "id": null,
    "metadata": {},
    "name": "CarryForwardSuggestedActionMutation",
    "operationKind": "mutation",
    "text": "mutation CarryForwardSuggestedActionMutation(\n  $noteId: ID!\n  $type: String!\n) {\n  noteCarryForwardBlocks(noteId: $noteId, type: $type) {\n    note {\n      actionItemsCarriedForward\n      talkingPointsCarriedForward\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "831e1c3a07cc56901097ac2f60b46b70";

export default node;
